// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"6e611e43","787":"7a79f6af","913":"4d263453"}[chunkId] + ".chunk.js";
};